<template>
  <base-modal
    v-model="showModal"
    :extra-classes="extraClasses"
    @base-modal:closed="handleCloseModal"
  >
    <template #modal-body>
      <saved-item-authentication
        :saved-item="item"
        :import-comment="importComment"
      />
    </template>
  </base-modal>
</template>

<script>
import SavedItemAuthentication from '@/components/modal/modal-content/saved-item-authentication.vue';
import BaseModal from '../base-modal.vue';

export default {
  components: {
    SavedItemAuthentication,
    BaseModal,
  },
  data() {
    return {
      showModal: false,
      emailOnly: false,
      registerImportComment: null,
      item: {
        id: null,
        type: null,
        companyId: null,
        companyName: null,
        title: null,
        url: null,
      },
    };
  },
  computed: {
    importComment() {
      switch (this.item.type) {
        case 'jobs':
          return 'Shortlist Job Modal';
        case 'companies':
          return 'Follow Company Modal';
        case 'reviews':
          return 'Favourite Review Modal';
        default:
          return 'Register Modal';
      }
    },
    extraClasses() {
      if (this.item.id) {
        return 'Modal--noSpacing Modal--large Modal--saveItems';
      }
      return 'Modal--authOnly Modal--noSpacing';
    },
    isSavedItem() {
      return this.item.id !== null;
    },
  },
  created() {
    // Save Item Modal is bound to a vue instance in the footer of each page.
    // Vue will not destroy this instance. It will reuse for efficiency. Only the nested components are destroyed.
    this.$bus.$on('bus:global-modal:close', this.handleCloseModal);
    this.$bus.$on('bus:save-item-modal:open-login', (item) => {
      if (item) {
        this.item = item;
      } else {
        this.changeCurrentView('login-template');
      }
      this.openModal();
    });
  },

  mounted() {
    document.addEventListener('keyup', (e) => {
      if (this.showModal && e.keyCode === 27) {
        this.handleCloseModal();
      }
    });
  },

  methods: {
    openModal() {
      this.showModal = true;
    },
    handleCloseModal() {
      this.showModal = false;
      this.emailOnly = false;
      this.resetItem();
    },
    resetItem() {
      this.item = {
        id: null,
        type: null,
        companyId: null,
        companyName: null,
        title: null,
        url: null,
      };
    },
  },
};
</script>
